// extracted by mini-css-extract-plugin
export default {"container":"container--0piuS","title":"title--po1km","links":"links--YTcyf","image":"image--zUogm"};